import { LicensesApi, useAPIAction } from "melco-shared-logic";
import { LicencesListFiltersType } from "./LicencesListFiltersType";
import { isEmpty } from "lodash-es";

export const useDownloadLicenses = (
  licensesFilters: LicencesListFiltersType | undefined
) => {
  return useAPIAction(
    LicensesApi,
    async (api) => {
      const data = await api.exportSerialNumber({
        productCodes:
          licensesFilters?.products && !isEmpty(licensesFilters.products)
            ? licensesFilters.products
            : "",
        subscriptionCode:
          licensesFilters?.subscriptionLevel &&
            !isEmpty(licensesFilters.subscriptionLevel)
            ? licensesFilters.subscriptionLevel
            : "",
        referralCode:
          licensesFilters?.refferal && !isEmpty(licensesFilters.refferal)
            ? licensesFilters.refferal
            : "",
        batch:
          licensesFilters?.batchNumber && !isEmpty(licensesFilters.batchNumber)
            ? licensesFilters.batchNumber
            : "",
        cancelled:
          licensesFilters?.state && !isEmpty(licensesFilters.state)
            ? licensesFilters.state
            : "false",
        serialNumber:
          licensesFilters?.serialNumber &&
            !isEmpty(licensesFilters.serialNumber)
            ? licensesFilters.serialNumber
            : "",
        searchText:
          licensesFilters?.searchText && !isEmpty(licensesFilters.searchText)
            ? licensesFilters?.searchText
            : "",
      });
      //  console.log(data)
      return {
        successMessages: [],
        data,
      };
    },
    { translationPrefix: "global" }
  );
};
